import { Cell } from './Cell';
import { useActiveSolution } from '../../context/ActiveSolutionContext';

export const EmptyRow = () => {
  const activeSolution = useActiveSolution();
  const emptyCells = Array.from(Array(activeSolution.solution.length));

  return (
    <div className="flex justify-center mb-1">
      {emptyCells.map((_, i) => (
        <Cell key={i} />
      ))}
    </div>
  );
};
